import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { DashboardService } from '../../../services/dashboard.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-available-cv',
  templateUrl: './available-cv.component.html',
  styleUrls: ['./available-cv.component.css'],
  providers: [DashboardService]
})
export class AvailableCvComponent implements OnInit {

  urlForAllCv: string;
  folderId: string;
  authUser: any = {};
  folderFileType: string;
  cvList: Array<any> = [];
  private constants = Constants;

  constructor(
    private cookieManagerService: CookieManagerService,
    private DashboardService: DashboardService,
  ) { }

  ngOnInit() {
    let $this = this;
    // get url of all cvs
    this.urlForAllCv = this.constants.allCvsUrl;
    // get cv folder ID
    this.folderId = this.constants.driverCvFolderId;
    //get folder file type in google
    this.folderFileType = this.constants.folderMinTypeInGoogle;
    // get login user details
    this.getAuthUser();
    // check the permission to view the widget
    this.checkAdminUserPermission();
    
  }

  getGoogleFileList(folderId) {
    this.DashboardService.getAvailableCvs({ folderId }).subscribe(
      res => {
        this.cvList = Object.keys(res.data.fileList).map((key) => { return res.data.fileList[key] });
      }
    );
  }

  /**
 * kaushalya
 * 2017-07-11
 * get log user details from the cookies
 */
  getAuthUser() {
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.authUser = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  /**
   * kaushalya
   * 2017-07-11
   * check user is adminUser or supervisor to give view permission for div
   */

  checkAdminUserPermission() {
    if (this.authUser.user_role_id != WorkConstants.basicConstans.adminRoleId && this.authUser.user_role_id != WorkConstants.basicConstans.supervisorRoleId) {
      $('#cv-list').hide();
    } else {
      this.getGoogleFileList(this.folderId);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/available-cv/available-cv.component.ts